import { getTimeZone } from './getTimeZone';


export const getQueryParams = (url = window.location.search) => {
  const params = {};
  const search = url.startsWith('?') ? url : '?' + url.split('?')[1] || '';
  const query = new URLSearchParams(search);
  for (const [key, value] of query.entries()) {
    params[key] = value;
  }
  return params;
};

export function isMobileDevice() {
  return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

export function isIOSDevice() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent) && !window.MSStream;
}

export function isAndroidDevice() {
  return /Android/i.test(navigator.userAgent);
}

let linkprefix = "";

let bodyText = "Okay Boggler... what do you have to say...";

let smsNumber = process.env.REACT_APP_PHONE_NUMBER;
let whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER;

if(isMobileDevice()) {
  if(isAndroidDevice()) {
    linkprefix = "smsto:";
  } else {
    linkprefix = "sms://";
  }
} else {
  linkprefix = "sms://";
}

let smsLinkURLToSendOnClick = encodeURI(linkprefix+smsNumber);
if(process.env.REACT_APP_QA_MODE == false || process.env.REACT_APP_QA_MODE == "false") {
   console.log("QA Mode is OFF... Prod is ON!");
} else {
  if(window.localStorage.getItem("buckish-qa-password") === "super-duper-pooper") {
      console.log("QA Mode is ON but Password is correct");
   } else {
      console.log("QA Mode is ON and Password is incorrect");
   }
}

export const openMessengerApp = (language, platform = "whatsapp", showBodyText = false, toPhoneNumber = whatsappNumber, sayWhat = bodyText) => {
  
  let theBodyText = showBodyText ? `?body=${sayWhat}` : "";
  let whatsappLinkURLToSendOnClick = "whatsapp://send?phone=" + toPhoneNumber;

  if(platform === "sms") {
      window.open(smsLinkURLToSendOnClick+theBodyText, "_self");
  } else {
    theBodyText = showBodyText ? `&text=${sayWhat}` : "";
    window.open(whatsappLinkURLToSendOnClick+theBodyText, "_self")
  }

}

let API_URL = process.env.REACT_APP_API_URL || "https://the-boggler-api-96bc2fa97f2d.herokuapp.com/api";

if(process.env.NODE_ENV === "development" || process.env.REACT_APP_QA_MODE == "true") {
  API_URL = "http://localhost:4242/api";
}

export const generateRandomString = (length) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const authenticateUser = async (title, p) => {


  if(p === "boggler-happy-path") {
    let step = ""
    if(title === "upload") {
      step = "1-initial-outreach-after-payment-sent";
    }
    if(title === "blog") {
      step = "2-uploaded-screenshots";
    }
    if(title === "get") {
      step = "4-closing-ask-sent";
    }
    return { response: { status: 200 }, data: {
      success: true,
      step: step,
      stripe_checkout_session_id: "",
      ip_info: "",
      happyPathUser: true,
      message: 'Special Access' 
    }};
  }

  try {

    const response = await fetch(API_URL + '/journalist/validate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ title, p })
    });

    let data = await response.json();
    data.happyPathUser = false;
    return { response, data };

  } catch (error) {
    console.error('Error:', error);
    return { response: { status: 200 }, data: { success: false, happyPathUser: false, message: 'Internal Server Error' } };
  }
};

export const getLanguage = () => {
  return window.localStorage.getItem("buckish-language") || "english";
}

export const setLanguage = (preferredLanguage) => {
  if(preferredLanguage === "sinhala") {
    window.localStorage.setItem("buckish-language", "sinhala");
  } else {
    window.localStorage.setItem("buckish-language", "english");
  }
};

export const authenticateGuideUser = async () => {

  const response = await fetch(`${process.env.REACT_APP_API_URL}/guide/login/check`, {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${window.localStorage.getItem('guideToken')}`
      }
    })

    const data = await response.json();

    if (data.success) {
        // Handle successful login
        console.log("guide logged in successfully");
        const { isLoggedIn, guide } = data;
        localStorage.setItem('guideData', JSON.stringify(guide));
        if(!isLoggedIn) {
            window.location.replace("/");
        }
    } else {
        // Handle login error
        console.error("guide login failed");
    }
    return data;
  }

  export const getCustomerCallTimeString = (unixMilliseconds, bogglerTimeZone) => {
      if(!unixMilliseconds) return "";
      const { zone } = getTimeZone(bogglerTimeZone);
      function formatAtZoneFromUnix(unixMilliseconds, timeZone, locale) {
          const d = new Date(unixMilliseconds);        // timestamp is UTC by spec
          return d.toLocaleString(locale, {
            timeZone,
            year: 'numeric', month: 'short', day: '2-digit',
            hour: '2-digit', minute: '2-digit'
          });
      }
      return formatAtZoneFromUnix(unixMilliseconds, zone, navigator.language || 'en-US');
  }

  export async function alertNativeFirst({ title, message, setShowWebAlert, action }) {
    // Fallback to IonAlert programmatically or a custom modal
    setShowWebAlert({ show: true, title: title, message: message, action: action });
}

 export const getGuideTypeImageUrlByHyphenatedTitle = async (hyphenatedTitle) => {
      if(!hyphenatedTitle || hyphenatedTitle === "" || hyphenatedTitle === "other") {
          return `https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/default-boggler-guide-profile-picture.png`;
      } else {
        try {
          const info = await guideTypeInfoFromHyphen(hyphenatedTitle);
          return info.imageUrl || `https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/default-boggler-guide-profile-picture.png`;
        } catch (error) {
            console.error("Error fetching guide type image URL:", error);
            return `https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/default-boggler-guide-profile-picture.png`;
        }
      }
  }

   export const getGuideTypeLabel = (hyphenatedTitle) => {
      if(!hyphenatedTitle || hyphenatedTitle === "") {
          return "";
      } else {
          const words = hyphenatedTitle?.split("-");
          const capitalizedWords = words?.map(word => capitalize(word));
          return capitalizedWords?.join(" ");
      }
  }

  export const getGuideTypeImageUrl = (profilePictureKey) => {
      if(!profilePictureKey || profilePictureKey === "" || profilePictureKey === "other") {
          return `https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/default-boggler-guide-profile-picture.png`;
      } else {
          return `https://buckish-ghosted-maps.s3.us-west-1.amazonaws.com/${profilePictureKey}`;
      }
  }

  export const getArticleByTitle = (title) => {
      const vowels = ['A', 'E', 'I', 'O', 'U', 'a', 'e', 'i', 'o', 'u'];
      if(title && title.length > 0 && vowels.includes(title.charAt(0))) {
          return "an";
      } else {
          return "a";
      }
  }

  export const capitalize = (s) => {
      if (typeof s !== 'string') return '';
      return s.charAt(0).toUpperCase() + s.slice(1);
  }

  export const fetchProfileData = async () => {  
      const sessionToken = window.localStorage.getItem('guideToken');      
      try {
          const response = await fetch(`${API_URL}/guide/profile`, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${sessionToken}`
              }
          });
          // Check if response is ok
          if (!response.ok) {
              console.error(`HTTP error! status: ${response.status}`);
              if (response.status === 401) {
                  // Unauthorized - token likely expired
                  localStorage.removeItem('guideToken');
                  localStorage.removeItem('guideTokenExpiry');
                  window.location.href = '/';
              }
              return;
          }

          // Check if response has content
          const contentType = response.headers.get('content-type');
          
          if (!contentType || !contentType.includes('application/json')) {
              const responseText = await response.text();
              console.error('Response is not JSON:', responseText);
              return;
          }

          const data = await response.json();
          
          if (!data.success) {
              if (data.expiredToken) {
                  localStorage.removeItem('guideToken');
                  localStorage.removeItem('guideTokenExpiry');
                  window.location.href = '/';
              }
              return;
          } else { 
              return data;
          }
          
      } catch (error) {
          console.error("Error fetching profile data:", error);
          console.error("Error details:", {
              name: error.name,
              message: error.message,
              stack: error.stack
          });
          
          // Check if it's a network error
          if (error.name === 'TypeError' && error.message.includes('fetch')) {
              console.error("Network error - check your connection and API URL:", API_URL);
          }
      }
  };

  export const fetchFinancialData = async () => {
      const sessionToken = window.localStorage.getItem('guideToken');      
      try {
          const response = await fetch(`${API_URL}/guide/finances`, {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${sessionToken}`
              }
          });
          const data = await response.json();
          return data;
      } catch (error) {
          console.error("Error fetching financial data:", error);
          return null;
      }
  };

  export const guideTypeInfoFromHyphen = async (type) => {
      let result = null;
      try {
        result = await fetch(`${API_URL}/guide/guide-type-info/${type}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            }
        }).catch((error) => {
            console.error("Error fetching guide type info:", error);
        });
        const data = await result?.json();
        const dataInfo = data?.guideType;
        if(!dataInfo) {
            return {};
        }
        return {
          presumedGender:   dataInfo?.presumedGender,
          pronoun1: dataInfo?.pronoun1, 
          pronoun2: dataInfo?.pronoun2,
          title: dataInfo?.title, 
          description: dataInfo?.description, 
          profilePictureKey: dataInfo?.profilePictureKey, 
          imageUrl: getGuideTypeImageUrl(dataInfo?.profilePictureKey)
        };
  } catch (error) {
      console.error("Error fetching guide type info:", error);
      return {};
  }
}